import { MixedFont } from "../../PresentationalComponents/MixedFont";
import styles from "./LatestUpdates.module.css";

export function Update({ date, alpha, description, type }) {
  return (
    <div className={styles.latest} style={{ opacity: alpha }}>
      <div className={styles.latestBar}>
        <div className={styles.filledCircle}></div>
        <div className={styles.bar}></div>
      </div>
      <div className={styles.latestText}>
        <label>{date}</label>
        <h3>
          <MixedFont inputText={description} />
        </h3>
        <label>[ {type} ]</label>
      </div>
    </div>
  );
}
